
import DistributionNewComponent from "../../../components/distributions/New.vue";

export default {
  components: {
    DistributionNewComponent,
  },
};
